var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCampaigneBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.308-164.001q-27.008 0-45.657-18.65-18.65-18.65-18.65-45.658v-503.382q0-27.008 18.65-45.658 18.649-18.65 45.657-18.65h318.154V-744H218.308q-4.616 0-8.462 3.846-3.847 3.847-3.847 8.463v503.382q0 4.616 3.847 8.463 3.846 3.846 8.462 3.846h503.383q4.615 0 8.462-3.846 3.846-3.847 3.846-8.463v-318.154h51.999v318.154q0 27.008-18.65 45.658-18.65 18.65-45.657 18.65H218.308Zm117.692-134v-51.998h267.999v51.998H336Zm0-108v-51.998h267.999v51.998H336Zm0-108v-51.998h267.999v51.998H336Zm346.001-106v-72h-72V-744h72v-72h51.998v72h72v51.999h-72v72h-51.998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCampaigneBold);
export default __webpack_public_path__ + "static/media/new-campaigne-bold.50060fe1ab694eab0aa8ae3852a4a9bd.svg";
export { ForwardRef as ReactComponent };